import { render, staticRenderFns } from "./Accounts2.vue?vue&type=template&id=203bf294&"
import script from "./Accounts2.vue?vue&type=script&lang=js&"
export * from "./Accounts2.vue?vue&type=script&lang=js&"
import style0 from "./Accounts2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports